import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThankYouPageV1Component } from './thank-you-page-v1/thank-you-page-v1.component';
import { ThankYouPageMaoComponent } from './thank-you-page-mao/thank-you-page-mao.component';
import { ThankYouPageTandemComponent } from './thank-you-page-tandem/thank-you-page-tandem.component';
import { ThankYouPageUpsellComponent } from './thank-you-page-upsell/thank-you-page-upsell.component';
// import { ThankYouPageMaoComponent } from './thank-you-page-mao/thank-you-page-mao.component';



@NgModule({
  declarations: [
    ThankYouPageV1Component,
    ThankYouPageMaoComponent,
    ThankYouPageTandemComponent,
    ThankYouPageUpsellComponent
  ],
  imports: [
    CommonModule
  ], 
  exports: [
    ThankYouPageV1Component,
    ThankYouPageMaoComponent,
    ThankYouPageTandemComponent,
    ThankYouPageUpsellComponent
  ]
})
export class ThankYouPagesModule { }
